/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { Modal, Box } from "@mui/material";
import "./CustomModal.css";
interface ModalProps {
  isModalOpen?: any;
  modalWidth?: any;
  modalHeight?: string;
  overflowY?: any;
  overflowX?: any;
  padding?: any;
  height?: string;
}

const CustomModal: React.FC<React.PropsWithChildren<ModalProps>> = ({

  modalHeight,
  modalWidth,
  children,
  overflowY,
  overflowX,
  padding = "1.75em",
  height,
  isModalOpen
}) => {
  return (
    <Modal open={isModalOpen} disableEscapeKeyDown={false}>
      <>
        <Box
          style={{
            padding: padding,
            borderRadius: "0.938em",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            background: "#ffffff 0% 0% no-repeat padding-box",
            width: modalWidth,
            height: height ?? "auto",
            maxHeight: modalHeight,
            overflowY: overflowY ? overflowY : "",
            outline: "none",
            overflowX: overflowX ? overflowX : "",
          }}
        >
          {children}
        </Box>
      </>
    </Modal>
  );
};

export default CustomModal;
